import { TextAnchor } from './BarChart.props';
import { ALLOWED_ANCHORS } from './BarChart.const';

export function isValidAnchor(anchor: string): anchor is TextAnchor {
  return ALLOWED_ANCHORS.includes(anchor as TextAnchor);
}
